"use client";

import React from "react";
import { GalleryProps } from "./props";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "@ui/components/carousel";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import Image from "next/image";
import { useDeviceType } from "../../../../hooks/ui";
import { resetSyncCdnImageSize } from "../../../../utils/common";

const Gallery: React.FC<GalleryProps> = ({ images }) => {
  const formatedImages = images.map((image) => image.url);

  const resizedImages = resetSyncCdnImageSize({
    images: formatedImages,
    width: 1440,
    height: 1080,
    // format: ".avif", // vamos desistir do avif para ganhar desempenho no loading
  });

  const { deviceType } = useDeviceType();

  const carouselOptions = {
    align: "start" as const,
    slidesToScroll: deviceType === "mobile" ? 1 : 2,
    containScroll: "trimSnaps" as const,
    breakpoints: {
      "(min-width: 768px)": {
        slidesToScroll: 2,
      },
    },
  };

  return (
    <div className="w-full mx-auto relative mt-10">
      <PhotoProvider
        maskOpacity={0.8}
        bannerVisible={false}
        toolbarRender={() => <></>}
      >
        <Carousel
          className="relative"
          opts={carouselOptions}
          style={{
            borderRadius: deviceType === "mobile" ? "0px" : "12px",
            overflow: "hidden",
          }}
        >
          <CarouselContent className="-ml-2 md:-ml-4">
            {resizedImages.map((image, index) => (
              <CarouselItem
                key={index}
                className={`pl-2 md:pl-4 ${
                  deviceType === "mobile" ? "basis-full" : "md:basis-1/2"
                }`}
              >
                <PhotoView src={image}>
                  <div className="group cursor-pointer relative overflow-hidden rounded-lg md:rounded-xl bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 dark:border-gray-700">
                    <div className="relative aspect-[4/3] w-full overflow-hidden">
                      <Image
                        src={image}
                        alt={`Imagem ${index + 1}`}
                        fill
                        className="object-cover group-hover:scale-105 transition-transform duration-500 ease-out"
                        sizes="(max-width: 768px) 100vw, 50vw"
                        loading={index === 0 ? "eager" : "lazy"}
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300" />
                    </div>
                  </div>
                </PhotoView>
              </CarouselItem>
            ))}
          </CarouselContent>

          <CarouselPrevious className="bg-white/95 hover:bg-white dark:bg-gray-900/95 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-300 shadow-lg hover:shadow-xl border-0 backdrop-blur-sm absolute left-2 md:left-4 top-1/2 transform -translate-y-1/2 z-10 h-10 w-10 transition-all duration-300 hover:scale-110" />
          <CarouselNext className="bg-white/95 hover:bg-white dark:bg-gray-900/95 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-300 shadow-lg hover:shadow-xl border-0 backdrop-blur-sm absolute right-2 md:right-4 top-1/2 transform -translate-y-1/2 z-10 h-10 w-10 transition-all duration-300 hover:scale-110" />
        </Carousel>
      </PhotoProvider>
    </div>
  );
};

export default Gallery;
